<template>
    <AppLoadingContainer :predicate="!isLoaded">
        <div class="card-body">
            <BTable
                    :current-page="filterOptions.page"
                    :fields="tableFields"
                    :items="charges"
                    :per-page="filterOptions.pageSize"
                    :responsive="true"
                    primary-key="id"
                    show-empty
                    striped
                    table-class="table-align-middle">

                <template v-slot:cell(cost)="row">
                    {{row.item.cost | currency}}
                </template>

                <!-- Footer Pagination -->
                <template v-slot:custom-foot>
                    <b-tr>
                        <b-td :colspan="tableFields.length">
                            <AppTablePagination
                                    :page.sync="filterOptions.page"
                                    :pageSize.sync="filterOptions.pageSize"
                                    :totalCount.sync="totalCharges"
                            ></AppTablePagination>
                        </b-td>
                    </b-tr>
                </template>
            </BTable>
        </div>
    </AppLoadingContainer>
</template>

<script>
    import AppLoadingContainer from "../shared/AppLoadingContainer";
    import AzureBillingService from "../../services/AzureBillingService";
    import {currency} from "../../filters/Currency";
    import AppTablePagination from "../shared/AppTablePagination";

    export default {
        components: {
            AppLoadingContainer,
            AppTablePagination
        },
        filters: {
            currency
        },
        data() {
            return {
                charges: [],
                totalCharges: 0,
                isLoaded: false,
                filterOptions: {
                    page: 1,
                    pageSize: 10
                },
                tableFields: [
                    {
                        key: 'meterCategory',
                        label: 'Meter Category',
                    },
                    {
                        key: 'cost',
                        label: 'Cost',
                        thClass: 'text-right',
                        tdClass: 'text-right'
                    }
                ]
            }
        },
        props: {
            billingId: {
                type: String,
                required: true
            },
            subscriptionId: {
                type: String,
                required: true
            }
        },
        created() {
            const vm = this;
            AzureBillingService.getSubscriptionCharges(this.billingId, this.subscriptionId)
                .then(function (response) {
                    vm.charges = response;
                    vm.totalCharges = response.length;
                }).catch(() => {
                vm.redirectToError();
            }).finally(() => vm.isLoaded = true);
        }
    }
</script>
